module.exports = __webpack_public_path__ + "static/media/arrow_down.f49779ba.svg";